import UIFetchService from "../../Service/UIFetchService";
import qs from "qs";
import { CreateIndicatorProps, DatasetRef } from "./model";

export const getIndexList = async (data: { name: string }) => {
  const res = await UIFetchService.get(
    `/api/v1/querying_indicator/indicators?${qs.stringify({
      key: data.name,
    })}`
  );
  return res;
};

export const duplicateIndicator = async (id: number) => {
  const res = await UIFetchService.post(
    `/api/v1/querying_indicator/indicators/${id}/clone`
  );
  return res;
};

export const delIndicator = async (id: number) => {
  const res = await UIFetchService.delete(
    `/api/v1/querying_indicator/indicators/${id}`
  );
  return res;
};

export const createIndicator = async (data: CreateIndicatorProps) => {
  const res = await UIFetchService.post(
    "/api/v1/querying_indicator/indicator",
    data
  );
  return res;
};

export const updateIndicator = async (
  data: CreateIndicatorProps,
  id: number
) => {
  const res = await UIFetchService.put(
    `/api/v1/querying_indicator/indicators/${id}`,
    data
  );
  return res;
};

export const getIndicator = async (id: number) => {
  const res = await UIFetchService.get(
    `/api/v1/querying_indicator/indicators/${id}`
  );
  return res;
};

// 获取文件夹列表
export const getDirList = (data?: { id?: number; name?: string }) => {
  return UIFetchService.get(
    `/api/v1/querying_indicator/indicators/directories?${qs.stringify({
      type: "INDICATOR",
      ...data,
    })}`
  );
};

// 更新文件夹列表
export const updateDir = (data: { id?: number; name: string }) => {
  return UIFetchService.post(
    "/api/v1/querying_indicator/indicators/directories",
    data
  );
};

// 删除文件夹
export const delDir = (id: number) => {
  return UIFetchService.delete(
    `/api/v1/querying_indicator/indicators/directory/${id}`
  );
};

// 移动指标文件夹
export const moveIndicator = (indicatorId: number, directoryId: number) => {
  return UIFetchService.method(
    "PATCH",
    `/api/v1/querying_indicator/indicator/${indicatorId}/directory/${directoryId}`
  );
};

export const getIndicatorRef = (indicatorId: number): Promise<DatasetRef> => {
  return UIFetchService.get(
    `/api/v1/querying_indicator/indicators/${indicatorId}/references`
  );
};

export const getFolderRef = (directoryId: number): Promise<DatasetRef> => {
  return UIFetchService.get(
    `/api/v1/querying_indicator/indicators/directory/${directoryId}/references`
  );
};
